import { widget } from "@foretagsplatsen/widgetjs";

/**
 * `keyFigureDescriptionWidget` displays a description of a keyFigure in a
 * panel box.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} keyFigureDescriptionWidget
 */
function keyFigureDescriptionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.keyFigure = null;

	that.setKeyFigure = function (keyFigure) {
		my.keyFigure = keyFigure;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "panel" },
			html.div(
				{ klass: "panel-body" },
				html.h5(my.keyFigure ? my.keyFigure.getName() : ""),
				html.p(my.keyFigure ? my.keyFigure.getDescription() : ""),
			),
		);
	};

	return that;
}

export default keyFigureDescriptionWidget;
